import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  zh: {
    // 通用
    appName: '自行车配置管理系统',
    loading: '加载中...',
    save: '保存',
    cancel: '取消',
    delete: '删除',
    edit: '编辑',
    confirm: '确认',
    search: '搜索',
    export: '导出',
    upload: '上传',
    success: '成功',
    error: '错误',
    warning: '警告',
    info: '信息',
    noData: '暂无数据',
    total: '共',
    items: '个',
    
    // 导航
    dashboard: '仪表盘',
    configs: '配置列表',
    configBuilder: '装车创建',
    componentLibrary: '零件库',
    standardsGuide: '新国标标准',
    uploadConfig: '上传配置',
    compare: '配置对比',
    generate: '智能生成',
    competitors: '竞品分析',
    trends: '行业趋势',
    profile: '个人资料',
    logout: '退出登录',
    
    // 认证
    login: '登录',
    register: '注册',
    email: '邮箱',
    password: '密码',
    username: '用户名',
    fullName: '姓名',
    loginSuccess: '登录成功',
    registerSuccess: '注册成功',
    loginFailed: '登录失败',
    registerFailed: '注册失败',
    
    // 配置相关
    configName: '配置名称',
    bikeType: '自行车类型',
    usage: '用途',
    totalPrice: '总价',
    totalWeight: '总重量',
    components: '零件',
    componentCount: '零件数量',
    uploadDate: '上传时间',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    description: '描述',
    tags: '标签',
    
    // 零件类别
    frame: '车架',
    fork: '前叉',
    wheel: '轮组',
    brake: '刹车',
    drivetrain: '变速',
    handlebar: '把组',
    saddle: '坐垫',
    pedal: '脚踏',
    chain: '链条',
    crankset: '牙盘',
    other: '其他',
    
    // 自行车类型
    roadBike: '公路车',
    mountainBike: '山地车',
    cityBike: '城市车',
    foldingBike: '折叠车',
    eBike: '电助力车',
    gravelBike: '砾石车',
    trackBike: '场地车',
    kidsBike: '童车',
    
    // 用途
    racing: '竞速',
    commuting: '通勤',
    leisure: '休闲',
    offroad: '越野',
    touring: '长途',
    daily: '日常',
    
    // 操作
    add: '添加',
    create: '创建',
    update: '更新',
    remove: '移除',
    clone: '克隆',
    favorite: '收藏',
    unfavorite: '取消收藏',
    view: '查看',
    download: '下载',
    import: '导入',
    batchDelete: '批量删除',
    selectAll: '全选',
    deselectAll: '取消全选',
    
    // 上传
    dragDropUpload: '拖拽文件到此处上传',
    supportedFormats: '支持 .xlsx, .xls, .csv 格式',
    uploadSuccess: '上传成功',
    uploadFailed: '上传失败',
    parseSuccess: '解析成功',
    parseFailed: '解析失败',
    
    // 对比
    selectConfigs: '选择配置',
    priceComparison: '价格对比',
    specsComparison: '规格对比',
    performanceRadar: '性能雷达',
    priceShare: '价格占比',
    overallScore: '综合得分',
    compareAtLeast2: '请至少选择2个配置',
    compareAtMost5: '最多只能对比5个配置',
    
    // 生成
    budget: '预算',
    priority: '优先级',
    pricePerformance: '性价比',
    lightweight: '轻量化',
    performance: '性能',
    durability: '耐用性',
    generateConfig: '生成配置',
    aiGenerating: 'AI 生成中...',
    
    // 竞品分析
    brand: '品牌',
    model: '型号',
    specs: '规格',
    price: '价格',
    weight: '重量',
    strengths: '优势',
    weaknesses: '劣势',
    addCompetitor: '添加竞品',
    aiAnalysis: 'AI 分析',
    manualAdd: '手动添加',
    radarChart: '雷达图',
    
    // 行业趋势
    marketSize: '市场规模',
    marketShare: '市场份额',
    growthRate: '增长率',
    keyTrends: '关键趋势',
    brandDynamics: '品牌动态',
    timeRange: '时间范围',
    last1Year: '近1年',
    last3Years: '近3年',
    last5Years: '近5年',
    allTime: '全部',
    dataSource: '数据来源',
    
    // 筛选排序
    filter: '筛选',
    sort: '排序',
    sortByNewest: '最新创建',
    sortByOldest: '最早创建',
    sortByPriceDesc: '价格从高到低',
    sortByPriceAsc: '价格从低到高',
    sortByWeightDesc: '重量从重到轻',
    sortByWeightAsc: '重量从轻到重',
    
    // 消息提示
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    updateSuccess: '更新成功',
    updateFailed: '更新失败',
    cloneSuccess: '克隆成功',
    cloneFailed: '克隆失败',
    exportSuccess: '导出成功',
    exportFailed: '导出失败',
    
    // 确认对话框
    confirmDelete: '确认删除',
    confirmDeleteMessage: '确定要删除这个配置吗？此操作不可恢复。',
    confirmBatchDelete: '确认批量删除',
    confirmBatchDeleteMessage: '确定要删除选中的配置吗？此操作不可恢复。',
    
    // 空状态
    noConfigs: '暂无配置',
    noConfigsDescription: '点击新建配置开始创建',
    noCompetitors: '暂无竞品数据',
    noCompetitorsDescription: '点击手动添加或使用AI智能分析来添加竞品',
    
    // 其他
    selected: '已选',
    page: '页',
    rowsPerPage: '每页行数',
    actions: '操作',
    details: '详情',
    back: '返回',
    next: '下一步',
    previous: '上一步',
    finish: '完成',
    refresh: '刷新'
  },
  
  en: {
    // General
    appName: 'Bike Config Manager',
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    confirm: 'Confirm',
    search: 'Search',
    export: 'Export',
    upload: 'Upload',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
    noData: 'No Data',
    total: 'Total',
    items: 'items',
    
    // Navigation
    dashboard: 'Dashboard',
    configs: 'Configs',
    configBuilder: 'Builder',
    componentLibrary: 'Component Library',
    standardsGuide: 'Standards Guide',
    uploadConfig: 'Upload',
    compare: 'Compare',
    generate: 'Auto Generate',
    competitors: 'Competitors',
    trends: 'Trends',
    profile: 'Profile',
    logout: 'Logout',
    
    // Auth
    login: 'Login',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    username: 'Username',
    fullName: 'Full Name',
    loginSuccess: 'Login successful',
    registerSuccess: 'Registration successful',
    loginFailed: 'Login failed',
    registerFailed: 'Registration failed',
    
    // Config
    configName: 'Config Name',
    bikeType: 'Bike Type',
    usage: 'Usage',
    totalPrice: 'Total Price',
    totalWeight: 'Total Weight',
    components: 'Components',
    componentCount: 'Component Count',
    uploadDate: 'Upload Date',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    description: 'Description',
    tags: 'Tags',
    
    // Component Categories
    frame: 'Frame',
    fork: 'Fork',
    wheel: 'Wheel',
    brake: 'Brake',
    drivetrain: 'Drivetrain',
    handlebar: 'Handlebar',
    saddle: 'Saddle',
    pedal: 'Pedal',
    chain: 'Chain',
    crankset: 'Crankset',
    other: 'Other',
    
    // Bike Types
    roadBike: 'Road Bike',
    mountainBike: 'Mountain Bike',
    cityBike: 'City Bike',
    foldingBike: 'Folding Bike',
    eBike: 'E-Bike',
    gravelBike: 'Gravel Bike',
    trackBike: 'Track Bike',
    kidsBike: 'Kids Bike',
    
    // Usage
    racing: 'Racing',
    commuting: 'Commuting',
    leisure: 'Leisure',
    offroad: 'Off-road',
    touring: 'Touring',
    daily: 'Daily',
    
    // Actions
    add: 'Add',
    create: 'Create',
    update: 'Update',
    remove: 'Remove',
    clone: 'Clone',
    favorite: 'Favorite',
    unfavorite: 'Unfavorite',
    view: 'View',
    download: 'Download',
    import: 'Import',
    batchDelete: 'Batch Delete',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    
    // Upload
    dragDropUpload: 'Drag & drop files here',
    supportedFormats: 'Supports .xlsx, .xls, .csv',
    uploadSuccess: 'Upload successful',
    uploadFailed: 'Upload failed',
    parseSuccess: 'Parse successful',
    parseFailed: 'Parse failed',
    
    // Compare
    selectConfigs: 'Select Configs',
    priceComparison: 'Price Comparison',
    specsComparison: 'Specs Comparison',
    performanceRadar: 'Performance Radar',
    priceShare: 'Price Share',
    overallScore: 'Overall Score',
    compareAtLeast2: 'Please select at least 2 configs',
    compareAtMost5: 'Maximum 5 configs can be compared',
    
    // Generate
    budget: 'Budget',
    priority: 'Priority',
    pricePerformance: 'Price/Performance',
    lightweight: 'Lightweight',
    performance: 'Performance',
    durability: 'Durability',
    generateConfig: 'Generate Config',
    aiGenerating: 'AI Generating...',
    
    // Competitor Analysis
    brand: 'Brand',
    model: 'Model',
    specs: 'Specs',
    price: 'Price',
    weight: 'Weight',
    strengths: 'Strengths',
    weaknesses: 'Weaknesses',
    addCompetitor: 'Add Competitor',
    aiAnalysis: 'AI Analysis',
    manualAdd: 'Manual Add',
    radarChart: 'Radar Chart',
    
    // Industry Trends
    marketSize: 'Market Size',
    marketShare: 'Market Share',
    growthRate: 'Growth Rate',
    keyTrends: 'Key Trends',
    brandDynamics: 'Brand Dynamics',
    timeRange: 'Time Range',
    last1Year: 'Last 1 Year',
    last3Years: 'Last 3 Years',
    last5Years: 'Last 5 Years',
    allTime: 'All Time',
    dataSource: 'Data Source',
    
    // Filter & Sort
    filter: 'Filter',
    sort: 'Sort',
    sortByNewest: 'Newest First',
    sortByOldest: 'Oldest First',
    sortByPriceDesc: 'Price: High to Low',
    sortByPriceAsc: 'Price: Low to High',
    sortByWeightDesc: 'Weight: Heavy to Light',
    sortByWeightAsc: 'Weight: Light to Heavy',
    
    // Messages
    deleteSuccess: 'Deleted successfully',
    deleteFailed: 'Delete failed',
    saveSuccess: 'Saved successfully',
    saveFailed: 'Save failed',
    updateSuccess: 'Updated successfully',
    updateFailed: 'Update failed',
    cloneSuccess: 'Cloned successfully',
    cloneFailed: 'Clone failed',
    exportSuccess: 'Exported successfully',
    exportFailed: 'Export failed',
    
    // Confirm Dialogs
    confirmDelete: 'Confirm Delete',
    confirmDeleteMessage: 'Are you sure you want to delete this config? This action cannot be undone.',
    confirmBatchDelete: 'Confirm Batch Delete',
    confirmBatchDeleteMessage: 'Are you sure you want to delete selected configs? This action cannot be undone.',
    
    // Empty States
    noConfigs: 'No Configs',
    noConfigsDescription: 'Click to create your first config',
    noCompetitors: 'No Competitors',
    noCompetitorsDescription: 'Add competitors manually or use AI analysis',
    
    // Other
    selected: 'Selected',
    page: 'Page',
    rowsPerPage: 'Rows per page',
    actions: 'Actions',
    details: 'Details',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    finish: 'Finish',
    refresh: 'Refresh'
  }
};

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // 从 localStorage 读取保存的语言设置
    return localStorage.getItem('language') || 'zh';
  });
  
  // 保存语言设置到 localStorage
  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);
  
  const t = (key) => translations[language]?.[key] || translations.zh[key] || key;
  
  const toggleLanguage = () => {
    setLanguage(prev => prev === 'zh' ? 'en' : 'zh');
  };
  
  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
